import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import searchicon from '../assets/search.png';
import clearall from '../assets/clear_all.png';
import bookmark from '../assets/bookmarks.png';

const Search = () => {
  return (
    <div>
      <section className="searchtemplateview">
        <Container>
            <Row className='searchform'>
            <Col md="5">
            <div className='shopbestmatch'>
               <ul>
                  <li><img src={clearall} /></li>
                  <li><img src={bookmark} /></li>
                  <li><a href='#'>Best Match</a></li>
                  <li><a href='#'>Newest</a></li>
                  <li><a href='#'>Trending</a></li>
               </ul>
            </div>
            </Col>
            <Col md="7">
            <div class="search-bar">
               <select class="filter-dropdown">
                  <option value="latest">Latest</option>
                  <option value="popular">Popular</option>
                  <option value="trending">Trending</option>
               </select>
               <input
                  type="text"
                  class="search-input"
                  placeholder="Search Bringing Vendors Together........"
                  />
               <button class="search-button">
               <img src={searchicon} />
               </button>
            </div>
            </Col>
         </Row>
        </Container>
      </section>
    </div>
  );
};

export default Search;
    